/**
 * Toggle de tema (claro / oscuro / sistema). Dropdown DaisyUI con un
 * icono dinámico según la selección actual. La lógica vive en useTheme.
 */
import { Sun, Moon, Monitor, Check } from "lucide-react";
import clsx from "clsx";
import { useTheme, type ThemeMode } from "@/hooks/useTheme";

const OPTIONS: { value: ThemeMode; label: string; icon: typeof Sun }[] = [
  { value: "light", label: "Claro", icon: Sun },
  { value: "dark", label: "Oscuro", icon: Moon },
  { value: "system", label: "Sistema", icon: Monitor },
];

export function ThemeToggle() {
  const { mode, setMode, effective } = useTheme();
  const Icon = mode === "system" ? Monitor : effective === "dark" ? Moon : Sun;

  return (
    <div className="dropdown dropdown-end">
      <button
        type="button"
        tabIndex={0}
        className="btn btn-ghost btn-sm btn-square"
        aria-label="Cambiar tema"
        title="Cambiar tema"
      >
        <Icon className="size-4" />
      </button>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-box z-30 mt-2 w-44 p-1 shadow-lg border border-base-300"
      >
        {OPTIONS.map((o) => {
          const OIcon = o.icon;
          const active = mode === o.value;
          return (
            <li key={o.value}>
              <button
                type="button"
                onClick={() => setMode(o.value)}
                className={clsx("flex items-center gap-2 text-sm", active && "active")}
              >
                <OIcon className="size-4" />
                <span className="flex-1 text-left">{o.label}</span>
                {active && <Check className="size-3.5 text-primary" />}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
